import theme from '@styles/theme';
export default {
  wraper: {},
  container: {
    padding: '64px 40px 80px',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '1920px',
    margin: 'auto',
    justifyContent: 'space-between',
    '@media screen and (max-width: 1280px)': {
      padding: '20px 24px 64px'
    },
    '@media screen and (max-width: 850px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  imageContainer: {
    display: 'flex',
    width: 'calc(100% - (650px + 20px))',
    flexDirection: 'column',
    marginTop: '20px',
    paddingRight: '20px',
    '@media screen and (max-width: 1280px)': {
      width: '600px',
      minWidth: 'auto',
      paddingRight: '0px',
      maxWidth: '780px'
    },
    '@media screen and (max-width: 1200px)': {
      width: '480px'
    },
    '@media screen and (max-width: 1024px)': {
      marginRight: '50px'
    },
    '@media screen and (max-width: 850px)': {
      width: '100%',
      maxWidth: 'unset',
      marginRight: '0px',
      marginTop: '4px'
    }
  },
  carousel: {
    marginTop: '10px',
    display: 'flex',
    span: {
      justifyContent: 'center',
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      gap: '24px',
      '@media screen and (max-width: 1280px)': {
        width: '90%'
      },
      '@media screen and (max-width: 1200px)': {
        width: '100%'
      },
      '@media screen and (max-width: 1024px)': {
        width: '95%'
      },
      '@media screen and (max-width: 850px)': {
        width: '90%'
      }
    }
  },
  configContainer: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '650px',
    justifyContent: 'space-between',
    '@media screen and (max-width: 1280px)': {
      minHeight: 'inherit',
      width: ' calc(100% - 620px)',
      maxWidth: 'unset'
    },
    '@media screen and (max-width: 1024px)': {
      width: 'calc(100% - 500px)',
      marginTop: '18px'
    },
    '@media screen and (max-width: 850px)': {
      width: '100%',
      marginTop: '30px'
    }
  },
  configSkeleton: {
    '@media screen and (max-width: 1280px)': {
      width: '100% !important'
    }
  },
  configDescriptionSkeleton: {
    marginBottom: '24px',
    '@media screen and (max-width: 850px)': {
      display: 'none'
    }
  },
  priceSkeleton: {
    '@media screen and (max-width: 850px)': {
      marginTop: '32px'
    }
  },
  configSkeletonBoxes: {},
  configSection: {
    marginTop: '8px',
    span: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media screen and (max-width: 1280px)': {
        width: '100% !important',
        gap: '12px',
        span: {
          display: 'flex'
        }
      }
    }
  },
  priceSection: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '60px',
    maxWidth: '597px',
    marginTop: '24px',
    '@media screen and (max-width: 850px)': {
      marginTop: '12px',
      maxWidth: '100%'
    }
  },
  price: {
    padding: '2px 24px 0px 24px',
    width: 'auto',
    minWidth: '190px',
    backgroundColor: theme.rawColors.lightGrey300,
    textAlign: 'center',
    verticalAlign: 'middle',
    p: {
      font: theme.fonts.uniformExtra,
      fontWeight: theme.fontWeights.normal,
      fontSize: '26px',
      textWrap: 'nowrap',
      marginTop: '10px'
    }
  },
  addToCart: {
    width: '100%'
  },
  image: {
    height: '450px',
    display: 'flex',
    maxWidth: '1219px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '@media screen and (max-width: 850px)': {
      height: '360px'
    },
    img: {
      height: '100%',
      maxHeight: '450px',
      width: 'auto',
      objectFit: 'contain',
      '@media screen and (max-width: 850px)': {
        maxHeight: '300px'
      }
    }
  },
  productName: {
    marginBottom: '30px',
    h1: {
      marginTop: '0px',
      fontFamily: theme.fonts.uniformExtra,
      fontWeight: theme.fontWeights.normal,
      fontSize: '42px',
      lineHeight: '36px',
      textTransform: 'uppercase'
    },
    '@media screen and (max-width: 850px)': {
      display: 'none'
    }
  },
  productNameMobile: {
    display: 'none',
    '@media screen and (max-width: 850px)': {
      width: '100%',
      marginTop: '18px',
      display: 'block'
    },
    h1: {
      marginTop: '0px',
      marginBottom: '0px',
      fontFamily: theme.fonts.uniformExtra,
      fontWeight: theme.fontWeights.normal,
      fontSize: '42px',
      lineHeight: '36px',
      textTransform: 'uppercase'
    }
  },
  imageSkeleton: {
    width: '450px',
    height: '450px',
    '@media screen and (max-width: 850px)': {
      height: '300px',
      width: '300px'
    }
  },
  imageSkeletonContainer: {
    height: '450px',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media screen and (max-width: 850px)': {
      height: '300px'
    }
  },
  imageLoader: (loaded: boolean) => ({
    opacity: loaded ? 1 : 0
  })
};